"use client";

import React, { useState } from "react";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import { Loader, CircleAlert } from "lucide-react";
function CasesGrid() {
  const {
    posts,
    loading,
    error,
    setQuery
  } = usePosts();
  const [activeFilter, setActiveFilter] = useState("all");
  const handleFilterChange = (value: string) => {
    if (!value) return;
    setActiveFilter(value);
    if (value === "all") {
      setQuery({
        project_category: undefined
      });
    } else {
      setQuery({
        project_category: value
      });
    }
  };
  if (error) {
    return <div className="flex flex-col items-center justify-center py-12 text-center">
        <CircleAlert className="size-10 text-destructive mb-4" />
        <p className="text-lg font-medium text-foreground">Unable to load the gallery.</p>
        <p className="text-muted-foreground mt-2">Please refresh to view our stories.</p>
      </div>;
  }
  return <div className="flex flex-col items-center w-full">
      <ToggleGroup type="single" value={activeFilter} onValueChange={handleFilterChange} className="mb-10 flex-wrap justify-center gap-1 md:gap-2">
        <ToggleGroupItem value="all" aria-label="All Stories" className="font-sans text-[10px] md:text-xs uppercase tracking-widest px-2 md:px-3">
          All Stories
        </ToggleGroupItem>
        <ToggleGroupItem value="weddings" aria-label="Weddings" className="font-sans text-[10px] md:text-xs uppercase tracking-widest px-2 md:px-3">
          Weddings
        </ToggleGroupItem>
        <ToggleGroupItem value="engagements" aria-label="Engagements" className="font-sans text-[10px] md:text-xs uppercase tracking-widest px-2 md:px-3">
          Engagements
        </ToggleGroupItem>
        <ToggleGroupItem value="editorials" aria-label="Editorials" className="font-sans text-[10px] md:text-xs uppercase tracking-widest px-2 md:px-3">
          Editorials
        </ToggleGroupItem>
      </ToggleGroup>

      {loading ? <div className="flex justify-center items-center py-20 w-full">
          <Loader className="size-10 animate-spin text-primary/40" />
        </div> : posts.length === 0 ? <div className="text-center py-20 w-full">
          <p className="text-lg text-muted-foreground font-serif italic">No stories found in this collection.</p>
        </div> : <div className="columns-1 md:columns-2 lg:columns-3 gap-6 w-full">
          {posts.map((post, i) => <div key={post.id} data-index={i} className="break-inside-avoid mb-6 group relative rounded-md overflow-hidden border border-border/50 bg-card shadow-sm hover:shadow-xl transition-shadow duration-500 flex flex-col">
              <div className="relative w-full overflow-hidden bg-muted">
                {}
                <img src={post.featuredImage || `/img/wedding_narrative_${i % 3 + 1}.png`} alt={post.title} className="w-full h-auto min-h-[250px] object-cover transition-transform duration-1000 group-hover:scale-105" />
                
                {}
                <div className="absolute inset-0 bg-background/90 opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex flex-col justify-center items-center text-foreground p-6 text-center z-10 backdrop-blur-sm">
                  <h4 className="text-lg font-medium mb-4 font-default text-foreground tracking-tight">Collection Details</h4>
                  <div className="space-y-2 text-sm">
                    <p className="flex flex-col items-center">
                      <span className="text-muted-foreground text-[10px] uppercase tracking-widest font-sans">Location</span>
                      <span className="font-serif italic">{post.customFields?.location || "Private Estate"}</span>
                    </p>
                    <div className="w-8 h-px bg-border mx-auto my-2"></div>
                    <p className="flex flex-col items-center">
                      <span className="text-muted-foreground text-[10px] uppercase tracking-widest font-sans">Aesthetic</span>
                      <span className="font-serif italic">{post.customFields?.aesthetic || "Soft Film, Natural Light"}</span>
                    </p>
                  </div>
                </div>
              </div>
              
              <div className="p-6 flex flex-col flex-grow">
                <div className="flex gap-2 mb-4 flex-wrap">
                  {post.categories && post.categories.length > 0 ? post.categories.slice(0, 2).map(cat => <Badge key={cat.id} variant="secondary" className="bg-accent/50 text-accent-foreground hover:bg-accent/70 border-transparent font-sans text-[10px] uppercase tracking-tighter">
                        {cat.name}
                      </Badge>) : <Badge variant="secondary" className="bg-accent/50 text-accent-foreground hover:bg-accent/70 border-transparent font-sans text-[10px] uppercase tracking-tighter">
                      Gallery
                    </Badge>}
                </div>
                
                <h3 className="text-xl font-medium text-foreground mb-4 font-default line-clamp-2 tracking-tight">
                  {post.title}
                </h3>
                
                <div className="mt-auto pt-4">
                  <Link to={post.link || "#"} className="w-full block">
                    <Button variant="outline" className="w-full rounded-md border-border hover:bg-primary hover:text-primary-foreground transition-colors duration-500 font-sans text-xs uppercase tracking-widest">
                      View Narrative
                    </Button>
                  </Link>
                </div>
              </div>
            </div>)}
        </div>}
    </div>;
}
export default function OurCases() {
  const wp_query_params = {
    post_type: "project",
    per_page: 9,
    order: "desc",
    orderby: "date"
  };
  const wp_query = new WP_Query(wp_query_params);
  return;
}